import { ComponentType } from 'react';

import lazyPreload from 'utils/lazyPreload/lazyPreload';

import PATHS, { TEACHER_PREFIX } from './paths';

const ClassroomExercisesPage = lazyPreload(() => import('pages/ClassroomExercisesPage/ClassroomExercisesPage'));
const ClassroomPage = lazyPreload(() => import('pages/ClassroomPage/ClassroomPage'));
const DashboardPage = lazyPreload(() => import('pages/DashboardPage/DashboardPage'));
const Exercises = lazyPreload(() => import('pages/Exercises/Exercises'));
const ExercisesSetsPage = lazyPreload(() => import('pages/ExercisesSetsPage/ExercisesSetsPage'));
const FacebookLoginCallback = lazyPreload(() => import('pages/FacebookLoginCallback/FacebookLoginCallback'));
const GoogleLoginCallback = lazyPreload(() => import('pages/GoogleLoginCallback/GoogleLoginCallback'));
const HelpPage = lazyPreload(() => import('pages/HelpPage/HelpPage'));
const LoginBySchoolPage = lazyPreload(() => import('pages/LoginBySchoolPage/LoginBySchoolPage'));
const LoginPage = lazyPreload(() => import('pages/LoginPage/LoginPage'));
const OnGoPage = lazyPreload(() => import('pages/OnGoPage/OnGoPage'));
const Page404 = lazyPreload(() => import('pages/Page404/Page404'));
const PasswordResetPage = lazyPreload(() => import('pages/PasswordResetPage/PasswordResetPage'));
const Register = lazyPreload(() => import('pages/Register/Register'));
const RegisterByMail = lazyPreload(() => import('pages/RegisterByMail/RegisterByMail'));
const Sheets = lazyPreload(() => import('pages/Sheets/Sheets'));
const SubjectSelect = lazyPreload(() => import('pages/SubjectSelect/SubjectSelect'));
const TeacherDashboardPage = lazyPreload(() => import('pages/TeacherDashboardPage/TeacherDashboardPage'));
const UserSettingsPage = lazyPreload(() => import('pages/UserSettingsPage/UserSettingsPage'));
const UserStatsPage = lazyPreload(() => import('pages/UserStatsPage/UserStatsPage'));
const TeacherLayout = lazyPreload(() => import('root/TeacherLayout/TeacherLayout'));

type Route = {
  path: string;
  element: ComponentType;
  transition?: boolean;
  index?: boolean;
  onlyForPremiumUser?: boolean;
  name: string;
};

export type NestedRoute = Route & {
  subRoutes?: Route[];
};

const authRoutes: NestedRoute[] = [
  {
    path: PATHS.LOGIN,
    element: LoginPage,
    transition: true,
    name: 'Zaloguj się',
  },
  {
    path: PATHS.LOGIN_BY_SCHOOL,
    element: LoginBySchoolPage,
    transition: true,
    name: 'Zaloguj na konto szkolne',
  },
  {
    path: PATHS.REGISTER,
    element: Register,
    transition: true,
    name: 'Rejestracja',
  },
  {
    path: PATHS.FB_CALLBACK,
    element: FacebookLoginCallback,
    transition: true,
    name: 'Logowanie przez Facebook',
  },
  {
    path: PATHS.GOOGLE_CALLBACK,
    element: GoogleLoginCallback,
    transition: true,
    name: 'Logowanie przez Google',
  },
  {
    path: PATHS.REGISTER_BY_MAIL,
    element: RegisterByMail,
    transition: true,
    name: 'Rejestracja przez email',
  },
  {
    path: PATHS.PASSWORD_RESET,
    element: PasswordResetPage,
    transition: true,
    name: 'Resetuj hasło',
  },
  {
    path: '*',
    element: Page404,
    transition: true,
    name: '404',
  },
];

const internalRoutes: NestedRoute[] = [
  {
    path: PATHS.ROOT,
    element: DashboardPage,
    transition: true,
    name: 'Menu główne',
  },
  {
    path: PATHS.EXERCISES,
    element: Exercises,
    transition: true,
    name: 'Zadania',
  },
  {
    path: PATHS.SHEETS,
    element: Sheets,
    transition: true,
    name: 'Arkusze',
  },
  {
    path: PATHS.EXERCISES_SETS,
    element: ExercisesSetsPage,
    transition: true,
    name: 'Zestawy zadań',
    onlyForPremiumUser: true,
  },
  {
    path: PATHS.USER_SETTINGS,
    element: UserSettingsPage,
    transition: true,
    name: 'Ustawienia',
  },
  {
    path: `${PATHS.USER_SETTINGS}/:dialogToOpen`,
    element: UserSettingsPage,
    transition: true,
    name: 'Ustawienia',
  },
  {
    path: PATHS.SUBJECT_SELECT,
    element: SubjectSelect,
    transition: false,
    name: 'Wybierz przedmiot',
  },
  {
    path: PATHS.HELP,
    element: HelpPage,
    transition: false,
    name: 'Pomoc',
  },
  {
    path: PATHS.ON_GO,
    element: OnGoPage,
    transition: true,
    name: 'W głowie',
  },
  {
    path: PATHS.MY_PROGRESS,
    element: UserStatsPage,
    transition: true,
    name: 'Statystyki',
  },
  {
    path: TEACHER_PREFIX,
    element: TeacherLayout,
    transition: false,
    name: 'Panel nauczyciela',
    subRoutes: [
      {
        path: PATHS.TEACHER_DASHBOARD,
        element: TeacherDashboardPage,
        transition: false,
        name: 'Panel nauczyciela',
        index: true,
      },
      {
        path: PATHS.CLASSROOM,
        element: ClassroomPage,
        transition: false,
        name: 'Moi uczniowie',
      },
      {
        path: PATHS.CLASSROOM_EXERCISES,
        element: ClassroomExercisesPage,
        transition: false,
        name: 'Zadania klasy',
      },
      {
        path: '*',
        element: Page404,
        transition: true,
        name: '404',
      },
    ],
  },
];

export { internalRoutes, authRoutes, LoginPage, DashboardPage, Page404 };
